// extracted by mini-css-extract-plugin
module.exports = {"container":"dogCard_container__1oD7Q","image":"dogCard_image__1APaG","imageContainer":"dogCard_imageContainer__1lV1-","data":"dogCard_data__2SbOF"};